module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transfer"
  }, [_c('t-list', {
    ref: "left",
    attrs: {
      "data": _vm.leftData,
      "title": _vm.titles && _vm.titles[0] ? _vm.titles[0] : 'items',
      "filterable": _vm.filterable,
      "show-footer": _vm.showFooter,
      "filter-placeholder": _vm.filterPlaceholderState,
      "filter-method": _vm.filterMethod,
      "not-found-text": _vm.notFoundTextState,
      "size": _vm.size,
      "checked-key": _vm.leftCheckedKeys,
      "render-content": _vm.renderContent,
      "direction": "left"
    }
  }, [_vm._t("left-footer")], 2), _vm._v(" "), _c('t-operation', {
    ref: "operation",
    attrs: {
      "operations": _vm.operations,
      "size": _vm.size
    }
  }), _vm._v(" "), _c('t-list', {
    ref: "right",
    attrs: {
      "data": _vm.rightData,
      "title": _vm.titles && _vm.titles[1] ? _vm.titles[1] : 'items',
      "filterable": _vm.filterable,
      "show-footer": _vm.showFooter,
      "filter-placeholder": _vm.filterPlaceholderState,
      "filter-method": _vm.filterMethod,
      "not-found-text": _vm.notFoundTextState,
      "size": _vm.size,
      "checked-key": _vm.rightCheckedKeys,
      "render-content": _vm.renderContent,
      "direction": "right"
    }
  }, [_vm._t("right-footer")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca7b976c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transfer/transfer.vue
// module id = 409
// module chunks = 0